const page = `

{settings}
document.title: Så mycket makt har Frankrikes president
og.title: Så mycket makt har Frankrikes president
og.image: http://quickshot.imgix.net/frankrike-presidentmakt/linjepuff.jpg?w=1000
og.twitterImage: http://quickshot.imgix.net/frankrike-presidentmakt/linjepuff.jpg?h=120&w=120&fit=crop
og.description: Hur mycket makt har egentligen Frankrikes president? Hur väljs premiärministern? Och vad händer om de två inte är överens?
og.url: http://pejl.svt.se/sa-mycket-makt-har-frankrikes-president
siteCatalyst.name: trumps-viktigaste-spelare
siteCatalyst.category: lyxartikel
{}
[+page]
{.video}
id: 13513123
storlek: full
{}


rubrik2: Så mycket makt har Frankrikes president



ingressmulti: Presidentämbetet är den allra högsta politiska posten i Frankrike, men landet har också en premiärminister som styr regeringen.
ingressmulti: Hur mycket makt har då egentligen de båda rollerna? Hur väljs premiärministern? Och vad händer om de två inte är överens?
ingressmulti: SVT Nyheter reder här ut skillnaden – och maktbalansen.
{.bild}
fil: frankrike-presidentmakt/prempres.jpg
bildtext: Franska presidenter med sina premiärministrar: François Hollande och Manuel Valls, samt Nicolas Sarkozy och François Fillon.
imgix.fp-y: 0
storlek: wide
{}

Presidentens roll och makt är inskriven i Frankrikes konstitution, som i sin nuvarande form härstammar från 1958. Den slår fast statsskicket och utgör grunden för Frankrikes femte republik i ordningen sedan revolutionen 1789.

Presidenten är Frankrikes statschef som representerar landet internationellt. Hen har det främsta ansvaret för Frankrikes utrikes- och försvarspolitik, och innehar titeln ”chef des armées” – överbefälhavare för landets militära styrkor.

mellanrubrik: Delas med premiärministern

I praktiken är det också vanligtvis presidenten som styr den franska inrikespolitiken, men inte per automatik. Den verkställande makten i Frankrike är nämligen uppdelad på två poster – presidenten och premiärministern. Systemet kallas semipresidentialism.

Premiärministern är regeringschef, och utses direkt av presidenten. Premiärministern utser sedan övriga ministrar till sin regering, som formellt godkänns av presidenten. Presidenten har sedan inte makt att avsätta sin utsedda premiärminister, utan bara uppmana denna att självmant avgå.

mellanrubrik: Nationalförsamlingen styr

Premiärministern svarar i stället direkt till nationalförsamlingen, det mäktigare underhuset i det franska parlamentet, och kan avsättas av ledamöterna genom en misstroendeomröstning.

Av den anledningen är presidenten i praktiken bunden att utse en premiärminister från den rådande majoriteten i nationalförsamlingen – även om den är av en annan politisk inriktning än presidenten.


{.bild}
fil: frankrike-presidentmakt/tidslinje_Frankrike_final.jpg
storlek: smalis
{}

När presidenten och majoriteten i nationalförsamlingen tillhör samma politiska riktning blir presidentens informella makt mycket större, då presidenten genom sitt utnämnande av en likasinnad premiärminister får stort inflytande över regeringens politik.

[Förenklat kan man beskriva det som att presidenten, som har rollen som talman i ministerrådet, stakar ut landets politik i samråd med ministrar inom de olika politiska ansvarsområdena, och att premiärministern och dennes regering sedan verkställer politiken.]

Premiärministern har de senaste årtiondena i många fall också fått bära hundhuvudet när en regering får den allmänna opinionen mot sig, och uppmanats avgå för att presidenten ska kunna tillsätta en ny premiärminister och följaktligen en ny regering i hopp om att vinna tillbaka folkets förtroende.

mellanrubrik: Premiärministern styr

När presidenten och majoriteten i nationalförsamlingen tillhör olika politiska inriktningar, blir presidenten i praktiken tvungen att utse en premiärminister vars politik inte stämmer överens med sin egen. Man talar då om att landet styrs genom cohabitation, franska för samboende men även en internationell term för detta politiska fenomen.

{.citat}
citat: Presidenten har bland annat det slutgiltiga ansvaret för beslut om att använda landets kärnvapen.
stil:strong
{}

Eftersom nästan alla presidentens beslut kräver en godkännande underskrift av premiärministern, blir det vid cohabitation de facto premiärministern som styr landet. Presidenten behåller dock formellt makten att just utse premiärminister, och även att upplösa nationalförsamlingen och utlysa nyval samt utlysa folkomröstningar. Hen behåller också rollen som stats- och arméchef, och därigenom ett ändå betydligt inflytande över utrikes- och försvarspolitiken. Presidenten har bland annat det slutgiltiga ansvaret för beslut om att använda landets kärnvapen.

Presidenten kan också förhala instiftandet av lagtexter som godkänts av parlamentet, genom att vägra skriva under dem. Hen saknar dock formell veto-rätt, då lagtexten i sådana fall skickas tillbaka till parlamentet för en ny granskning. Om parlamentet röstar igenom texten denna gång kan den antas utan presidentens godkännande.

mellanrubrik: Har skett tre gånger i historien

Cohabition har inträffat tre gånger under den femte republiken. Under den socialistiske presidenten François Mitterands mandatperiod (1981–1995) vann högern två gånger majoriteten i nationalförsamlingen: 1986–1988 var högerns Jacques Chirac premiärminister och 1993–1995 Édouard Balladur.

[Den längsta perioden av cohabitation inträffade 1997–2002. Två år in i Jacques Chiracs presidentskap vann vänsterpartierna egen majoritet i val till nationalförsamlingen, och Socialistpartiets Lionel Jospin utsågs till premiärminister.]
{.bild}
fil: frankrike-presidentmakt/lioneljospin.jpg
imgix.fp-y: 0
bildtext: Socialpariets Lionel Jospin och president Jacques Chirac, 2002.
foto: TT
{}
mellanrubrik: Ny regel stoppar cohabitation

Av naturliga skäl blir landet svårare att regera under perioder av cohabitation. Inför presidentvalet 2002, som då sammanföll med ett valår till nationalförsamlingen, genomfördes en folkomröstning på initiativ av president Chirac. Genom omröstningen beslutades att presidentens mandatperiod skulle förkortas från sju till fem år för att synkroniseras med nationalförsamlingens.

Sedan dess hålls nu presidentval i normalfall i slutet på våren vart femte år, och parlamentsval under sommaren. Tanken är att den allmänna opinionen inte ska hinna svänga alltför mycket och att presidenten ska ha möjlighet att säkra en stödjande majoritet i nationalförsamlingen.

Under de tre mandatperioder som ägt rum sedan dess har också presidenten alltid haft en grundläggande majoritet i nationalförsamlingen för en likasinnad regering.



    {.div}
      style.position: relative
      style.marginLeft: auto
      style.marginRight: auto
      style.maxWidth: 624px
      style.clear: both
      [.+content]
        {.bild}
        fil: frankrike-presidentmakt/puffbild.jpg
        storlek: wide
        {}
        {.div}
          style.position: absolute
          style.bottom: 0%
          style.marginLeft: 12px
          style.marginRight: 12px
          style.width: calc(100% - 24px)
          style.background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.75) 99%,rgba(0,0,0,0.75) 100%)
          style.background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.75) 99%, rgba(0,0,0,0.75) 100%)
          style.background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.75) 99%,rgba(0,0,0,0.75) 100%)
          style.filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#bf000000',GradientType=0 )
          style.color: #fff
          style.textAlign: center
          style.fontSize:20px
          style.fontWeight:600
          [.+content]
            Vägen till Elyséepalatset
            luft: -65px
            – så går det franska valet till
            {.div}
              style.backgroundColor: rgba(255,255,255,0.25)
              style.boxShadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.5)
              style.fontSize: 25px
              style.color:#fff
              style.fontWeight: 300
              style.paddingBottom:4px
              [.+content]
              luft: -47px
               text: [ pejl.svt.se/franska-presidentvalet | http://pejl.svt.se/franska-presidentvalet | white]


              []
            {}
            []
        {}
      []
    {}

mellanrubrik: Val till nationalförsamlingen i juni

I år avgörs presidentvalets andra omgång den 7 maj och val till nationalförsamlingen hålls den 11 och 18 juni. Liksom i presidentvalet hålls valet i två omgångar, då 577 valkretsar, fördelade mellan Frankrike, landets utomeuropeiska områden och franska medborgare bosatta utomlands, alla röstar fram var sin ledamot, enligt ett system som har många likheter med presidentvalet.

I och med systemet med 577 självständiga valkretsar, blir mandatfördelningen i nationalförsamlingen inte nödvändigtvis direkt representativ för den sammanlagda opinionen bland medborgarna. Hypotetiskt skulle exempelvis Socialistpartiet kunna vinna varje valkrets med 51 procent av rösterna, och då få 100 procent av platserna i nationalförsamlingen – trots att bara drygt hälften av befolkningen röstat så.

mellanrubrik: Senaten mindre mäktig

Det ska nämnas att det franska parlamentet också har ett överhus, senaten, men dess makt är begränsad i förhållande till nationalförsamlingen. De 348 senatorerna väljs för en sexårsperiod, men inte direkt av folket, utan av i sin tur folkvalda lokala församlingar runt om i Frankrikes territorium. Hälften av senatorerna byts ut på en treårsbasis.

Senaten deltar liksom nationalförsamlingen i det lagstiftande arbetet, men i frågor då de två kamrarna är oense i sina omröstningar kan premiärministern ge sista ordet till nationalförsamlingen.
{.div}
  style.position: relative
  style.marginTop: 20px
  style.marginLeft: auto
  style.marginRight: auto
  style.paddingLeft: 12px
  style.paddingRight: 12px
  style.maxWidth: 600px
  style.backgroundColor: #eee
  style.clear: both
  style.paddingBottom: 10px

  [.+content]

    {.div}
      style.fontWeight:400
      style.fontSize:20px
      style.paddingTop:0px
      style.backgroundColor:#e6e5e5
      style.paddingLeft: 12px
      style.marginLeft: -12px
      style.marginRight: -12px
      style.marginBottom: -10px
      [.+content]
        Det krävs för att bli president i Frankrike
      []
    {}
    [För att kunna ställa upp i presidentvalet i Frankrike måste man …]

    […] Vara fransk medborgare och över 18 år

    […] Vara inskriven på en röstlängd i Frankrike

    […] Ha samlat in minst 500 namnunderskrifter från folkvalda franska politiker, med viss geografisk spridning

    […] Kunna visa upp en deklaration över egendom och tillgångar

    […] Ha skapat ett kampanjkonto

    […] Inte redan ha genomfört två sammanhängande mandatperioder som president

[]
{}

linje:

{.sharebuttons}
title:Så mycket makt har Frankrikes president
url:http://pejl.svt.se/sa-mycket-makt-har-frankrikes-president
{}


rubrik5: [Text:|em] Mathias Gerdfeldter
luft: -50px
[ mathias.gerdfeldter@svt.se | mailto:mathias.gerdfeldter@svt.se  | black]
rubrik5: [Grafik:|em] Eva Eliasson
luft: -50px
[ eva.eliasson@svt.se | mailto:eva.eliasson@svt.se  | black]

luft:50


[]
`;

export default page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/frankrike-presidentmakt.js
 **/